import { useCallback, useMemo, useState } from 'react';
export var usePopover = function () {
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var isOpen = useMemo(function () { return !!anchorEl; }, [anchorEl]);
    var setPopoverOpen = useCallback(function (event) {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    var setPopoverClose = useCallback(function () {
        setAnchorEl(null);
    }, [setAnchorEl]);
    return { anchorEl: anchorEl, setPopoverClose: setPopoverClose, setPopoverOpen: setPopoverOpen, isOpen: isOpen };
};
